export default {

	init() {
		console.log('video init...');

        document.addEventListener("DOMContentLoaded", this.bindEvents);

		$('.hero-img:has(.autoplay-hero-video) a.hide-popup-player').on('click', function(){
			const parentDiv = $('.hero-img');
			parentDiv.find('.autoplay-hero-video').each(function(){
				this.pause();
				console.log($(this));
			});
			console.log(parentDiv);
			console.log(parentDiv.find('.autoplay-hero-video'));
		});
	},

    bindEvents() {
	  Video.startStopAutoplay();
	  $(window).on("click keydown keyup keypress mousedown mouseup mousemove wheel scroll touchstart touchmove touchend", Video.startStopAutoplay);
    },
  
	getVideoProvider(url) {
		// YouTube
		if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(url)) {
			return 'youtube';
		}

		// Vimeo
		if (/^(https?:\/\/)?(player\.|www\.)?(vimeo\.com)\/.+$/.test(url)) {
			return 'vimeo';
		}

		// Simian
		if (/^https?:\/\/definition6.gosimian.com\/share\/v\/.+$/.test(url)) {
			return 'simian';
		}
		if (/^https?:\/\/bridgenext.gosimian.com\/share\/v\/.+$/.test(url)) {
			return 'simian';
		}

		return null;
	},

	getVideoId(provider, url) {
		if (provider === 'youtube') {
			const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  			return url.match(regex) ? RegExp.$2 : url;
		}

		if (provider === 'vimeo') {
			const regex = /^.*(vimeo.com\/|video\/)(\d+).*/;
  			return url.match(regex) ? RegExp.$2 : url;
		}

		if (provider === 'simian') {
			const regex = /^.*(gosimian.com\/|share\/|v\/)([^\/]+).*/;
  			return url.match(regex) ? RegExp.$2 : url;
		}
	},

	getVideoEmbed(url, aspect = '16by9') {
		let provider = Video.getVideoProvider(url);
		let videoId = Video.getVideoId(provider, url);
		let source = url;
		let name = 'VideoEmbed';
				
		if (provider === 'youtube') {
			source = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&amp;origin=${location.origin}&amp;controls=1&autoplay=0&amp;modestbranding=1&amp;rel=0`;
			name = 'YoutubeEmbed';
		}

		if (provider === 'vimeo') {
			source = `https://player.vimeo.com/video/${videoId}?api=1&amp;autoplay=0&amp;title=0&amp;byline=0&amp;portrait=0`;
			name = 'VimeoEmbed';
		}

		if (provider === 'simian') {
			source = `https://bridgenext.gosimian.com/share/v/${videoId}/false/auto/auto/5F00AA/000000`;
			name = 'SimianEmbed';
		}

		let template = `
			<div class="embed-responsive embed-responsive-16by9">
				<div class="embed-responsive-item video-aspect-${aspect}">
					<iframe src="${source}" name="${name}" loading="lazy" style="background:#000" scrolling="no" frameborder="0" allowFullScreen webkitAllowFullScreen></iframe>
				</div>
			</div>
		`;

		return template;
	},

	stopAllVideos() {
		let players = document.querySelectorAll('[name=SimianEmbed]');
		players.forEach(function(elem, index) {
			elem.contentWindow.postMessage('stop', '*');
		});

		let ytPlayers = document.querySelectorAll('[name=YoutubeEmbed]');
		ytPlayers.forEach(function(elem, index) {
			elem.contentWindow.postMessage('{"event":"command","func":"stopVideo"}', '*');
		});

		let vimeoPlayers = document.querySelectorAll('[name=VimeoEmbed]');
		vimeoPlayers.forEach(function(elem, index) {
			elem.contentWindow.postMessage('{"method":"pause"}', '*');
		});
	},

	startStopAutoplay() {
		$('.autoplay-hero-video').each(function(){
			Video.startStopAutoplayVideoEl(this, true);
		});
		$('.accordion-images .accordion-image-toggle:not(.hidden) video').each(function(){
			Video.startStopAutoplayVideoEl(this);
		});
	},

	isElInFrame(el) {
		// Get the element's bounding rectangle
		const rect = el.getBoundingClientRect();

		// Check if the element is in the viewport
		return rect.bottom >= 0 && rect.top <= window.innerHeight;
	},

	startStopAutoplayVideoEl(el, autoload = false) {
		if(autoload) Video.loadFromDataSrc(el);

		if($(el).is(':visible')) {
			Video.loadFromDataSrc(el);
			const inFrame = Video.isElInFrame(el);

			if(inFrame) {
				if(el.paused) el.play();
			} else {
				if(!el.paused) el.pause();
			}
		} else {
			el.pause();
		}
	},

	loadFromDataSrc(el) {
		if(!$(el).attr('src').length && $(el).attr('data-src').length) {
			$(el).attr('src', $(el).attr('data-src')); 
			$(el).attr('data-src', ''); 
		}
	},

	iOS() {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
		// iPad on iOS 13 detection
		|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}
};